import { ref } from "vue";

export function useCanvasDrawing() {
  const isDrawing = ref(false);

  const startDrawing = () => {
    isDrawing.value = true;
  };

  const stopDrawing = () => {
    isDrawing.value = false;
  };

  return {
    isDrawing,
    startDrawing,
    stopDrawing,
  };
}
